module.exports = __webpack_public_path__ + "static/media/EG-M301.50e0898d.jpg";